module.exports = __webpack_public_path__ + "img/bri.00a9dc50.svg";